export const sxFontFamily = {
  "font-family": "PF DIN Text Pro",
};

export const sxFontFamilyNormal = {
  ...sxFontFamily,
  "font-style": "normal",
};

export const sxFont_12_400 = {
  ...sxFontFamilyNormal,
  "font-size": "12px",
  "font-weight": "400",
  "line-height": "12px",
};

export const sxFont_14_400 = {
  ...sxFontFamilyNormal,
  "font-size": "14px",
  "font-weight": "400",
  "line-height": "14px",
};

export const sxFont_16_400 = {
  ...sxFontFamilyNormal,
  "font-size": "16px",
  "font-weight": "400",
  "line-height": "16px",
};

export const sxFont_18_400 = {
  ...sxFontFamilyNormal,
  "font-size": "18px",
  "font-weight": "400",
  "line-height": "18px",
};

export const sxFont_20_400 = {
  ...sxFontFamilyNormal,
  "font-size": "20px",
  "font-weight": "400",
  "line-height": "24px",
};

export const sxFont_22_400 = {
  ...sxFontFamilyNormal,
  "font-size": "22px",
  "font-weight": "400",
  "line-height": "22px",
};

export const sxFont_24_400 = {
  ...sxFontFamilyNormal,
  "font-size": "24px",
  "font-weight": "400",
  "line-height": "24px",
};

export const sxFont_12_500 = {
  ...sxFontFamilyNormal,
  "font-size": "12px",
  "font-weight": "500",
  "line-height": "12px",
};

export const sxFont_14_500 = {
  ...sxFontFamilyNormal,
  "font-size": "14px",
  "font-weight": "500",
  "line-height": "14px",
};

export const sxFont_16_500 = {
  ...sxFontFamilyNormal,
  "font-size": "16px",
  "font-weight": "500",
  "line-height": "16px",
};

export const sxFont_18_500 = {
  ...sxFontFamilyNormal,
  "font-size": "18px",
  "font-weight": "500",
  "line-height": "18px",
};

export const sxFont_20_500 = {
  ...sxFontFamilyNormal,
  "font-size": "20px",
  "font-weight": "500",
  "line-height": "20px",
};

export const sxFont_22_500 = {
  ...sxFontFamilyNormal,
  "font-size": "22px",
  "font-weight": "500",
  "line-height": "22px",
};

export const sxFont_24_500 = {
  ...sxFontFamilyNormal,
  "font-size": "24px",
  "font-weight": "500",
  "line-height": "24px",
};

export const sxFont_32_500 = {
  ...sxFontFamilyNormal,
  "font-size": "32px",
  "font-weight": "500",
  "line-height": "32px",
};

export const sxFont_34_500 = {
  ...sxFontFamilyNormal,
  "font-size": "34px",
  "font-weight": "500",
  "line-height": "34px",
};
